import classNames from 'classnames'
import { FC } from 'react'
import { MentionStance } from 'src/services/aiListeningApi/brandProfile.types'
import styles from './charts.module.scss'
import { formatNumber, formatPercent } from '../utils'

type Split = Record<MentionStance, { count: number; share: number }>

interface StanceSplitProps {
  compact?: boolean
  split: Split
}

const STANCES: { key: MentionStance; label: string }[] = [
  { key: 'recommended', label: 'Recommended' },
  { key: 'neutral', label: 'Neutral mention' },
  { key: 'critical', label: 'Critical' },
]

// Recommended / Neutral mention / Critical: one bar split by share, and a
// chip per stance with its count and share.
export const StanceSplit: FC<StanceSplitProps> = ({
  compact = false,
  split,
}) => {
  const segments = STANCES.filter(({ key }) => (split[key]?.share ?? 0) > 0)

  return (
    <div
      className={classNames(styles.stance, { [styles.stanceCompact]: compact })}
    >
      <div className={styles.stanceBar}>
        {segments.length === 0 ? (
          <span className={styles.stanceEmpty} />
        ) : (
          segments.map(({ key }) => (
            <span
              className={classNames(styles.stanceSegment, styles[key])}
              key={key}
              style={{ flexGrow: split[key].share }}
            />
          ))
        )}
      </div>
      <div className={styles.stanceChips}>
        {STANCES.map(({ key, label }) => (
          <span
            className={classNames(styles.stanceChip, styles[key])}
            key={key}
          >
            <span className={styles.stanceDot} />
            <span className={styles.stanceLabel}>{label}</span>
            <strong>{formatNumber(split[key]?.count)}</strong>
            <span className={styles.stanceShare}>
              {formatPercent(split[key]?.share)}
            </span>
          </span>
        ))}
      </div>
    </div>
  )
}
